import { HubConnection, HubConnectionState } from "@aspnet/signalr";

export async function restartHubConnection(hubConnection: HubConnection) {
    if (hubConnection.state === HubConnectionState.Connected) {
        hubConnection.stop().then(() => hubConnection.start());
    }
    else {
        hubConnection.start();
    }
}